import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { PoAutoSettingPageRoutingModule } from './po-auto-setting-routing.module';

import { PoAutoSettingPage } from './po-auto-setting.page';
import { IonicSelectableModule } from 'ionic-selectable';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    PoAutoSettingPageRoutingModule,
    IonicSelectableModule
  ],
  declarations: [PoAutoSettingPage]
})
export class PoAutoSettingPageModule {}
